var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const ArrowShuffle = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M19 18.979L21 16.979L19 14.979M10.182 8.99998L8.602 6.82798C8.224 6.30798 7.619 6.00198 6.976 6.00398L3 6.02098M19 8L21 6L19 4M13.818 14L15.398 16.172C15.776 16.692 16.381 16.998 17.024 16.996L21 16.979M21 6.02099L17.024 6.00399C16.381 6.00099 15.776 6.30799 15.398 6.82799L8.602 16.172C8.224 16.692 7.619 16.998 6.976 16.996L3 16.979", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
